import React from 'react';
import Avatar from 'react-avatar';
import {Popup} from 'semantic-ui-react';
import '../index.scss';

const DYLAvatar = ({name, email, picture, maxInitials = 2, size = '22px', textSizeRatio = 2, position = 'bottom center', disabled = false, inactive = false, popup = true, onClick = () => {}, title }) => {
    const avatar = <Avatar name={name} title={title} maxInitials={maxInitials} className={`sb-avatar${inactive ? "--inactive" : ""}`} src={picture} round size={size} textSizeRatio={textSizeRatio} onClick={onClick} />;
    if (!popup) {
        return (
            <span style={{marginRight: 5}}>
                {avatar}
            </span>
        )
    }
    return (
        <Popup
            trigger={
                <span style={{marginRight: 5}}>
                    {avatar}
                </span>}
            content={
                <div>
                    {name}
                    <br/>
                    {email}
                </div>}
            position={position}
            inverted
            disabled={disabled}
        />
    )
}
export default DYLAvatar;
